/**
 * Custom Free Shipping Bar v8 (Barra de progreso)
 * - Actualiza la barra de progreso (.shipping-progress) cuando existe.
 * - Solo reescribe el texto si cambió, para no gatillar el MutationObserver en bucle.
 */

class FreeShippingManager {
  constructor() {
    this.init();
  }

  init() {
    // 1. Cargar estado inicial
    this.refreshAllBars();

    // 2. Escuchar clics GLOBALMENTE (Delegación de eventos)
    document.body.addEventListener('click', (e) => {
      const trigger = e.target.closest('.zone-switch-item');
      // Si el clic fue en un switch y NO en un enlace de políticas
      if (trigger && !e.target.closest('.zone-policy-link')) {
        e.preventDefault();
        const zoneName = trigger.dataset.zoneName;
        this.changeZone(zoneName);
      }
    });

    // 3. Escuchar cambios en el carrito
    document.addEventListener('cart:updated', () => this.fetchCart());
    
    // 4. Interceptar Fetch
    this.interceptFetch();

    // 5. Observer para detectar cambios en el DOM (mini cart abriéndose)
    this.observeDomChanges();
  }

  changeZone(zoneName) {
    localStorage.setItem('shipping_zone_preference', zoneName);
    this.updateActiveClasses(zoneName);
    this.fetchCart();
  }

  fetchCart() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        this.updateAllBarsData(cart.total_price);
      })
      .catch(e => console.error('Error shipping bar:', e));
  }

  refreshAllBars() {
    this.fetchCart();
    const currentZone = localStorage.getItem('shipping_zone_preference');
    if (currentZone) {
      this.updateActiveClasses(currentZone);
    }
  }

  updateAllBarsData(totalPrice) {
    // Seleccionamos TODAS las barras (arriba y mini cart)
    const bars = document.querySelectorAll('.custom-free-shipping-bar');
    const savedZone = localStorage.getItem('shipping_zone_preference');

    bars.forEach(bar => {
      // Determinar qué zona usar
      let activeItem = null;
      const switches = bar.querySelectorAll('.zone-switch-item');
      
      if (savedZone) {
        activeItem = Array.from(switches).find(item => item.dataset.zoneName === savedZone);
      }
      
      if (!activeItem && switches.length > 0) {
        activeItem = switches[0];
      }

      if (activeItem) {
        // Asegurar que la barra sea VISIBLE
        if (bar.style.display !== 'block') bar.style.display = 'block';

        // Asegurar que visualmente esté activo el switch correcto
        this.updateActiveClasses(activeItem.dataset.zoneName);
        
        // Calcular lógica
        const threshold = parseInt(activeItem.dataset.threshold, 10);
        const suffix = activeItem.dataset.successSuffix || '';
        const msgUnder = bar.dataset.messageUnder;
        const msgAt = bar.dataset.messageAt;
        const textEl = bar.querySelector('.custom-free-shipping-bar__text');

        const remaining = threshold - totalPrice;
        let html;

        if (remaining <= 0) {
          // META CUMPLIDA
          html = `${msgAt} <span style="font-weight:700">${suffix}</span>`;
        } else {
          // FALTA DINERO
          const formattedMoney = '$' + (remaining / 100).toLocaleString('es-CL');
          html = msgUnder.replace('[monto]', `<strong>${formattedMoney}</strong>`);
        }

        // Solo tocar el DOM si el texto cambió (evita bucle con el MutationObserver)
        if (textEl && textEl.dataset.rendered !== html) {
          textEl.innerHTML = html;
          textEl.dataset.rendered = html;
        }

        // Barra de progreso: lo que lleva el carro sobre la meta de la zona
        const progress = bar.querySelector('.shipping-progress');
        if (progress && threshold > 0) {
          const pct = Math.max(0, Math.min(100, (totalPrice / threshold) * 100));
          const fill = progress.querySelector('.shipping-progress__fill');
          if (fill) fill.style.width = pct + '%';
          progress.setAttribute('aria-valuenow', Math.round(pct));
          progress.classList.toggle('is-complete', pct >= 100);
        }
      }
    });
  }

  updateActiveClasses(zoneName) {
    const allSwitches = document.querySelectorAll('.zone-switch-item');
    allSwitches.forEach(item => {
      if (item.dataset.zoneName === zoneName) {
        item.classList.add('active');
      } else {
        item.classList.remove('active');
      }
    });
  }

  interceptFetch() {
    const originalFetch = window.fetch;
    window.fetch = function() {
      return originalFetch.apply(this, arguments).then((response) => {
        if (response.url.includes('/cart/add') || 
            response.url.includes('/cart/change') || 
            response.url.includes('/cart/update') ||
            response.url.includes('section_id')) { 
           setTimeout(() => document.dispatchEvent(new Event('cart:updated')), 500);
        }
        return response;
      });
    };
  }

  observeDomChanges() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          shouldUpdate = true;
        }
      });
      if (shouldUpdate) {
        if(this.debounceTimer) clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.refreshAllBars(), 300);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.freeShippingManager = new FreeShippingManager();
});
